module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-21.0ef799b7.png";